
  import { PaymentType } from '@/entities/finance/PaymentType'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class PaymentTypeCell extends Cell {
    declare item: PaymentType
    type = null

    async mounted () {
      if (!this.item?.id) return

      this.type = await this.fetchData({
        query: { name: 'fetch', model: 'PaymentType', params: { id: this.item.id } },
      })
    }

    get description () {
      const { type } = this

      return type?.description || ''
    }

    get color () {
      const { type } = this

      return type?.color || '#737373'
    }
  }
